'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSettingsInputComponent = function MdSettingsInputComponent(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 26.6v-3.2h10v3.2q0 1.7-1 2.9t-2.4 1.8v7.1h-3.4v-7.1q-3.2-1.1-3.2-4.7z m-6.8-23.2v6.6h3.4v10h-10v-10h3.4v-6.6q0-0.7 0.4-1.3t1.2-0.5 1.2 0.5 0.4 1.3z m13.4 6.6h3.4v10h-10v-10h3.2v-6.6q0-0.7 0.5-1.3t1.3-0.5 1.1 0.5 0.5 1.3v6.6z m-33.4 16.6v-3.2h10v3.2q0 3.6-3.2 4.7v7.1h-3.4v-7.1q-1.5-0.5-2.4-1.8t-1-2.9z m13.4 0v-3.2h10v3.2q0 1.7-0.9 2.9t-2.5 1.8v7.1h-3.2v-7.1q-1.5-0.5-2.5-1.8t-0.9-2.9z m-6.6-23.2v6.6h3.2v10h-10v-10h3.4v-6.6q0-0.7 0.5-1.3t1.1-0.5 1.3 0.5 0.5 1.3z' })
        )
    );
};

exports.default = MdSettingsInputComponent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/settings-input-component.js
// module id = 1170
// module chunks = 0